module.exports = __webpack_public_path__ + "img/location.7f239241.png";